import { BodyText, Link } from '@policygenius/mortar';
import { createUseStyles } from 'react-jss';

import styles from './styles';

const useStyles = createUseStyles(styles, { name: 'ApplicationDisclosure' });

const ApplicationDisclosure = () => {
  const classes = useStyles();

  return (
    <BodyText className={classes.disclosure} color="primary" size="small">
      By clicking Get My Rates, I provide my signature consenting to contact from Policygenius for
      products or services via email; live, automated, or prerecorded call; or text or SMS at the
      number I provide (message and data rates may apply and message frequency varies), and agree to
      the{' '}
      <Link
        href="https://www.policygenius.com/about/privacy/"
        size="inherit"
        target="_blank"
        variant="secondary"
      >
        Privacy Policy
      </Link>
      ,{' '}
      <Link
        href="https://www.policygenius.com/about/electronic-record-disclosure/"
        size="inherit"
        target="_blank"
        variant="secondary"
      >
        Consent to do Business Electronically
      </Link>
      , and{' '}
      <Link
        href="https://www.policygenius.com/about/terms/"
        size="inherit"
        target="_blank"
        variant="secondary"
      >
        Terms & Conditions
      </Link>
      . I understand that consent to phone communications is not a condition of purchase and that I
      can email{' '}
      <Link href="mailto:privacy@policygenius.com" size="inherit" variant="secondary">
        privacy@policygenius.com
      </Link>{' '}
      to revoke consent.
    </BodyText>
  );
};

export default ApplicationDisclosure;
